import { epicRequest, reduxFetchCreator, serverResponse } from 'app'

import type { ServerResponseSchema } from 'app'
import type { StageSchema } from 'tournaments'

export type ListFilter = { tournamentId: string }

const getInitialState = () =>
  serverResponse<StageSchema[]>({
    data: [],
  })

const list = reduxFetchCreator<'stagesList', ListFilter, ServerResponseSchema<StageSchema[]>>(
  'stagesList',
  getInitialState(),
  {
    start: (state, action) => ({ ...state, key: action.payload.tournamentId }),
  },
)

const stagesListEpic = epicRequest({
  actionType: list.actions.stagesList.type,
  debounce: 700,
  // @todo fix type
  errorAction: list.actions.stagesListError,
  fulfilledAction: list.actions.stagesListFulfilled,
  request: (action: { payload: ListFilter }) => ({
    method: 'get',
    url: `sports/soccer/tournament/${action.payload.tournamentId}/stages`,
  }),
  // @ts-ignore
  untilTypes: list.actions.stagesListCancel.type,
})

export const actions = {
  ...list.actions,
}

export const epics = [stagesListEpic]

export const { reducer } = list
